import { observer } from "mobx-react-lite";
import styles from "./UserPanel.module.css";
import { DefaultScrollBar } from "@/components/scrollbar/DefaultScrollBar/DefaultScrollBar";
import { Permissions } from "./Permissions/Permissions";
import { OtherUsers } from "./OtherUsers/OtherUsers";

export const Body = observer(() => {
  return (
    <div className={styles.overlayBody}>
      <div className={styles.body}>
        <div className={styles.permissionsPrimaryUser}>
          <Permissions />
        </div>
        <br />

        <OtherUsers />
      </div>
      <DefaultScrollBar scrollBar={{ positionMode: "over" }} />
    </div>
  );
});
